import {
  FaInstagram,
  FaMusic,
  FaSoundcloud,
  FaSpotify,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import {
  KYDAdminFeed,
  KYDSocialPlatforms,
} from "../../../../../common/interfaces/KYDOrganization";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Switch,
} from "@chakra-ui/react";

const SocialInput = ({
  type,
  updateDirtyText,
  dirtyText,
  onUpdateSocial,
  loading,
  feed,
}: {
  type: KYDSocialPlatforms;
  updateDirtyText: (obj: Record<string, any>) => void;
  dirtyText: Record<string, any>;
  onUpdateSocial: (type: string, link?: string, enabled?: boolean) => void;
  loading: Record<KYDSocialPlatforms | string, boolean>;
  feed: KYDAdminFeed | null;
}) => {
  let icon;
  let placeholder;
  switch (type) {
    case "twitter":
      icon = <FaTwitter />;
      placeholder = "Twitter Link";
      break;
    case "spotify":
      icon = <FaSpotify />;
      placeholder = "Spotify Link";
      break;
    case "instagram":
      icon = <FaInstagram />;
      placeholder = "Instagram Link";
      break;
    case "applemusic":
      icon = <FaMusic />;
      placeholder = "Apple Music Link";
      break;
    case "youtube":
      icon = <FaYoutube />;
      placeholder = "YouTube Link";
      break;
    case "soundcloud":
      icon = <FaSoundcloud />;
      placeholder = "Soundcloud Link";
      break;
    default:
      return null;
  }
  console.log("dirty", dirtyText);

  return (
    <InputGroup size={"md"} alignItems={"center"}>
      <InputLeftElement children={icon} />
      <Input
        maxW="500px"
        placeholder={placeholder}
        onChange={(e) => updateDirtyText({ [`${type}.link`]: e.target.value })}
        value={
          dirtyText[`${type}.link`] || feed?.organization.socials[type]?.link
        }
        pr="4.5rem"
      />
      {`${type}.link` in dirtyText && dirtyText[`${type}.link`] ? (
        <InputRightElement mr={"6rem"} width="4.5rem">
          <Button
            isDisabled={loading[`social.${type}`]}
            isLoading={loading[`social.${type}`]}
            onClick={() => onUpdateSocial(type, dirtyText[`${type}.link`])}
            h="1.75rem"
            size={"sm"}
          >
            Save
          </Button>
        </InputRightElement>
      ) : null}

      {feed?.organization.socials[type]?.link ? (
        <Switch
          colorScheme="green"
          defaultChecked={feed?.organization.socials[type]?.enabled}
          isDisabled={loading[`social.${type}`]}
          onChange={(e) => onUpdateSocial(type, undefined, e.target.checked)}
          ml={2}
        />
      ) : null}
    </InputGroup>
  );
};

export default SocialInput;
